<template>
  <figure class="cam">
    <div class="clip-media" @click="playing = true">
      <video v-if="playing" :src="cam.url" controls autoplay playsinline :poster="cam.posterUrl"></video>
      <template v-else>
        <img v-if="cam.posterUrl" :src="cam.posterUrl" :alt="cam.label || cam.file" loading="lazy" />
        <span class="play-badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l11-7z" /></svg></span>
      </template>
    </div>
    <figcaption class="cam-body">
      <p class="ct">{{ cam.label || cam.file }}</p>
      <span v-if="cam.size" class="cs">{{ cam.size }}</span>
      <a class="cdl" :href="cam.url" download>Save</a>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'CamCard',
  props: { cam: { type: Object, required: true } },
  data() {
    return { playing: false };
  },
};
</script>
